import React from 'react';
import PropTypes from 'prop-types';
import './Smoke.css';

const Smoke = (props) => {
  const { colors } = props;

  return (
    <div className="smoke-block">
      <div className="smoke-wrapper">
        {colors.map((color, index) => (
          <div
            className={`wave${index ? index + 1 : ''}`}
            style={{ background: color }}
            key={index.toString()}
          />
        ))}
      </div>
    </div>
  );
};

Smoke.propTypes = {
  colors: PropTypes.array,
};

export default Smoke;
